import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space, message } from "antd";
import { useState, useEffect } from "react";
import { serverFetch } from "@server";
import { fmtDateTimeFull } from "@extensions/utils";
import { tokenVidsLabel } from "@extensions/enums";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import "../company/company.css";

const MessageDialog = ({ id, onClose, onSuccess }) => {
  const isMobile = useViewportBreakpoint() === "mobile";
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    serverFetch("dialog")
      .then(data => {
        const dialog = Array.isArray(data) ? data.find(d => d.id === id) : null;
        if (dialog) {
          setItem(dialog);
          form.setFieldsValue({ name: dialog.name ?? "" });
        } else {
          message.error("Диалог не найден");
          onClose?.();
        }
      })
      .catch(e => {
        message.error(e.userMessage || "Ошибка загрузки диалога");
        onClose?.();
      })
      .finally(() => setLoading(false));
  }, [id, form, onClose]);

  const handleSave = () => {
    form.validateFields().then(values => {
      if (!item) return;
      setLoading(true);
      const payload = { ...item, name: values.name || null };
      serverFetch("dialog", { method: "PUT", bodyData: payload })
        .then(() => {
          message.success("Диалог обновлён");
          onSuccess?.();
          onClose?.();
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage || "Ошибка сохранения");
        });
    });
  };

  const formProps = isMobile
    ? { layout: "vertical", colon: false, disabled: loading, style: { width: "100%", maxWidth: "100%" } }
    : { layout: "vertical", colon: false, disabled: loading, style: { maxWidth: "100%" } };

  const formFields = (
    <>
      {item && (
        <>
          <Form.Item label="ID">
            <Input value={item.id} disabled />
          </Form.Item>
          <Form.Item label="Дата создания">
            <Input value={item.createdOn ? fmtDateTimeFull(item.createdOn) : ""} disabled />
          </Form.Item>
          <Form.Item label="Компания (ID)">
            <Input value={item.companyId} disabled />
          </Form.Item>
          {item.tokenName != null && item.tokenName !== "" && (
            <Form.Item label="Канал">
              <Input value={item.tokenName} disabled />
            </Form.Item>
          )}
          {item.code != null && item.code !== "" && (
            <Form.Item label="Код">
              <Input value={item.code} disabled />
            </Form.Item>
          )}
          <Form.Item label="Вид">
            <Input value={tokenVidsLabel(item.vid) ?? item.vid} disabled />
          </Form.Item>
          <Form.Item label="Телефон">
            <Input value={item.phone ?? ""} disabled />
          </Form.Item>
          <Form.Item label="ID последнего сообщения">
            <Input value={item.lastMessageId ?? ""} disabled />
          </Form.Item>
          <Form.Item label="Дата обновления">
            <Input value={item.lastUpdated ? fmtDateTimeFull(item.lastUpdated) : ""} disabled />
          </Form.Item>
          {item.lastMessageBody != null && item.lastMessageBody !== "" && (
            <Form.Item label="Текст последнего сообщения">
              <Input.TextArea value={item.lastMessageBody} disabled rows={3} />
            </Form.Item>
          )}
        </>
      )}
      <Form.Item name="name" label="Наименование">
        <Input placeholder="Наименование диалога" />
      </Form.Item>
      {!isMobile && (
        <Form.Item label=" ">
          <Space>
            <Button type="primary" className="misoft-btn" onClick={handleSave} loading={loading}>
              Сохранить
            </Button>
            <Button className="misoft-btn" onClick={() => onClose?.()}>
              Отмена
            </Button>
          </Space>
        </Form.Item>
      )}
    </>
  );

  if (!id) return null;

  return (
    <div>
      <div
        className={`misoft-modal-overlay${isMobile ? " company-base-overlay--mobile" : ""}`}
        onClick={e => e.target === e.currentTarget && onClose?.()}
      >
        <div
          className={`misoft-modal-content${isMobile ? " company-base-sheet--mobile" : ""}`}
          style={isMobile ? undefined : { width: 720, maxWidth: "min(720px, 100vw)" }}
          onClick={e => e.stopPropagation()}
        >
          {isMobile ? (
            <>
              <div className="company-base-sheet-header">
                <span className="company-base-sheet-title">Диалог</span>
                <Space size="small" className="company-base-sheet-actions">
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={handleSave}
                    loading={loading}
                    aria-label="Сохранить"
                    className="company-base-header-icon-btn"
                  />
                  <Button
                    type="default"
                    icon={<CloseOutlined />}
                    onClick={() => onClose?.()}
                    aria-label="Закрыть"
                    className="company-base-header-icon-btn"
                  />
                </Space>
              </div>
              <div className="company-base-sheet-body">
                <Form form={form} {...formProps}>
                  {formFields}
                </Form>
              </div>
            </>
          ) : (
            <>
              <div className="misoft-modal-title">
                <span>Диалог</span>
                <CloseOutlined
                  className="misoft-section-title-close"
                  onClick={() => onClose?.()}
                  style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}
                />
              </div>
              <Form form={form} {...formProps}>
                {formFields}
              </Form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageDialog;
